/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    } 
*/
export default {
  /**获取列表 */
  USER_MESSAGE_LIST_API: '/component/messageTaskRecive/listMessageTaskReciveByPage/',
  /**删除消息 */
  USER_MESSAGE_DEL_API: '/component/messageTaskRecive/removeMessageTaskRecive/',
  /**消息详情 */
  USER_MESSAGE_DETAIL_API: '/component/messageTaskRecive/detail/',
};
